import { DatePipe, formatDate, Location } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TableService } from '@app/shared/services/table.service';
import { NbDialogService, NbToastrService} from '@nebular/theme';
import { NgxLinkifyjsService } from 'ngx-linkifyjs';
import { MessageService } from './../../services/message.service';

import { DynamicFormCommonService } from '@app/shared/dynamic-form-common.service';
// import { NewReminderModalComponent } from '../new-reminder-modal/new-reminder-modal.component';
// import { SnoozeTimeComponent } from '../snooze-time/snooze-time.component';
//import { EventEmiterService } from '@app/shared/services/event-emiter.service';

@Component({
  selector: 'ngx-reminder-notification',
  templateUrl: './reminder-notification.component.html',
  styleUrls: ['./reminder-notification.component.scss']
})
export class ReminderNotificationComponent implements OnInit, OnChanges {

  @Input() reminderList = [];
  @Input() notificationList = [];
  @Input() loader = false;
  @Input() hideNotification = false;
  @Input() fullSizeTab = true;
  @Input() checkReminderRecord = false;

  @Input() getTablesForMenuData = [];
  @Input() unreadReminderCount = 0;
  @Input() unreadNotificationCount = 0;
  @Output() emitToOpen = new EventEmitter();
  @Output() closeReminder = new EventEmitter();
  @Output() ShowHideModel = new EventEmitter();

  // closeReminders

  @Output() emitToEdit = new EventEmitter();
  @Output() emitToLoadReminder = new EventEmitter();
  @Output() emitToLoadNotification = new EventEmitter();
  @Output() emitToRead = new EventEmitter();
  @Output() emitReminderRead = new EventEmitter();
  @Output() emitDeleted = new EventEmitter();
  users = [];
  systemConfigColor: any;

  constructor(private tableService: TableService, private datePipe: DatePipe, private cdr: ChangeDetectorRef,
    public route: ActivatedRoute,
    private router: Router,
    private dialogService: NbDialogService,
    private location: Location,
    public linkifyService: NgxLinkifyjsService,
    public toasterService: NbToastrService,
    public messageService: MessageService,
    public sanitizer: DomSanitizer,
    public formService: DynamicFormCommonService,
   // private eventEmiter: EventEmiterService,
  ) {
    this.tableService.$users.subscribe((res: any) => {
      this.users = res;
    })
    this.tableService.$systemConfig.subscribe((res: any) => {
      if (res) {
        this.systemConfigColor = res.IconColors;
      }
    })
  }

  ngOnInit() {
    console.log(this.unreadNotificationCount);
   }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['notificationList']) {
      this.notificationList = changes['notificationList'].currentValue;
    }
    this.addSenderInfo();
    this.cdr.detectChanges();
  }

  addSenderInfo() {
    this.notificationList.forEach(notification => {
      let user = this.users.find(user => user._id == notification.sender);
      if (user) {
        notification['sender'] = user;
      }
    })
  }

  openReminder(reminder) {
    this.emitToOpen.emit(reminder);
  }

  editReminder(reminder) {
    this.emitToEdit.emit(reminder);
  }

  changedTab($event) {
    setTimeout(() => {
      this.tableService.runCustomStyling();
    }, 100);
  }

  formatDate(value) {
    if (!value) {
      return "";
    }

    let currentDate = new Date();
    let data = this.datePipe.transform(value, "dd/MM/YYYY");
    let current = this.datePipe.transform(currentDate, "dd/MM/YYYY");

    if (data == current) {
      return formatDate(value, "h:mm a", "en");
    }

    return formatDate(value, "M/d/yy, h:mm a", "en");
  }

  scrollHandler(type, e) {
   console.log('check handler')
    if (type == 'reminder') {
      let diff = e.srcElement.scrollTop - (e.srcElement.scrollHeight - 352);

      if (diff == 0) {

        if (!this.loader)
          this.emitToLoadReminder.emit(true);
        e.preventDefault();
      }
    } else {

      let diff = e.srcElement.scrollTop - (e.srcElement.scrollHeight - 352);

      if (diff == 0) {

        if (!this.loader)
          this.emitToLoadNotification.emit(true);

        e.preventDefault();
      }
    }
  }

  previousLocation;

  tdClick(notification, tableId, tableName, _id) {

    this.emitToRead.emit(notification);

    let table = this.getTablesForMenuData.find(v => v.tableName == tableName);
    this.previousLocation = this.location.path();

    if (table) {
      if (table.viewInModal) {
        this.tableService.getDynamicTreeDataById(tableName, _id).subscribe((res: any) => {
          if (res.statusCode == 200) {
            this.location.replaceState("pages/tables/dynamic/" + tableId + "/" + tableName + "/" + _id);
            if (table.formWidth) {

              let width = (Number)(table.formWidth);
              if (width < 410) {
                width = 410
              }

              let wid: any = this.sanitizer.bypassSecurityTrustStyle((String)(width + 350));
              table.formWidth = wid.changingThisBreaksApplicationSecurity;
            }
            this.openViewModal(res.data, _id, table);
          }
        });
      } else {
        this.router.navigate(["/pages/tables/dynamic/" + tableId + "/" + tableName + "/" + _id,]);
      }
    }
  }

  async openViewModal(data, id, table) {

    let val: any = await this.formService.openAndCloseForm(data, table.tableName, this.getTablesForMenuData, true);

    const ref = this.dialogService.open(val.formComp, {
      closeOnEsc: false,
      context: val.formObj,
      closeOnBackdropClick: false,
    }).onClose.subscribe((resp) => {
      this.location.replaceState(this.previousLocation);
    });

  }

  reminderCompleted(value) {
    this.emitReminderRead.emit('read');
  }

}
